import { render, staticRenderFns } from "./ReadingAndTranslatingForm.vue?vue&type=template&id=a5c81b46&"
import script from "./ReadingAndTranslatingForm.vue?vue&type=script&lang=js&"
export * from "./ReadingAndTranslatingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports